import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { compare, fromBase64String, toBase64String, isNullOrWhiteSpace, split as split_1, replace as replace_1, substring as substring_1, join as join_1, trimEnd as trimEnd_1, trimStart as trimStart_1, startsWith } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { map } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { splitWhen } from "./Seq.js";
import { isUpper } from "../fable_modules/fable-library-js.4.24.0/Char.js";
import { min } from "../fable_modules/fable-library-js.4.24.0/Double.js";
import { get_UTF8 } from "../fable_modules/fable-library-js.4.24.0/Encoding.js";
import { ofNullable, map as map_1, bind, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { InvariantCulture_TryParseDecimal_Z721C83C5, InvariantCulture_TryParseDateTime_Z721C83C5, DateOnly_tryParse, Option_ofPair, Option_ofBool } from "./Common.js";
import { tryParse } from "../fable_modules/fable-library-js.4.24.0/Boolean.js";
import { FSharpRef } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { tryParse as tryParse_1 } from "../fable_modules/fable-library-js.4.24.0/Int32.js";

export function ensureStartsWith(prefix, s) {
    let matchValue;
    const s_1 = s;
    matchValue = ((s_1 === defaultOf()) ? "" : s_1);
    if (startsWith(matchValue, prefix, 3)) {
        return matchValue;
    }
    else {
        return prefix + matchValue;
    }
}

export function indexOf(c, s) {
    let s_1;
    return ((s_1 = s, (s_1 === defaultOf()) ? "" : s_1)).indexOf(c);
}

export function toLower(s) {
    let s_1;
    return ((s_1 = s, (s_1 === defaultOf()) ? "" : s_1)).toLowerCase();
}

export function toUpper(s) {
    let s_1;
    return ((s_1 = s, (s_1 === defaultOf()) ? "" : s_1)).toUpperCase();
}

export function trimWhiteSpace(s) {
    let s_1;
    return ((s_1 = s, (s_1 === defaultOf()) ? "" : s_1)).trim();
}

export function trimEndWhiteSpace(s) {
    let s_1;
    return ((s_1 = s, (s_1 === defaultOf()) ? "" : s_1)).trimEnd();
}

export function trimStart(c, s) {
    let s_1;
    return trimStart_1((s_1 = s, (s_1 === defaultOf()) ? "" : s_1), c);
}

export function trimEnd(c, s) {
    let s_1;
    return trimEnd_1((s_1 = s, (s_1 === defaultOf()) ? "" : s_1), c);
}

/**
 * From camelCase or PascalCase to kebab-case
 */
export function toKebab(s) {
    return toLower(join_1("-", map((value) => (value.join('')), splitWhen(isUpper, trimWhiteSpace(s).split("")))));
}

export function substring(start, length, s) {
    const matchValue = s.length | 0;
    if (matchValue === 0) {
        return "";
    }
    else {
        return substring_1(s, start, min(length, matchValue - start));
    }
}

export function replace(oldValue, newValue, s) {
    let s_1;
    return replace_1((s_1 = s, (s_1 === defaultOf()) ? "" : s_1), oldValue, newValue);
}

export function join(separator, chunks) {
    return join_1(separator, chunks);
}

export function split(separator, s) {
    let s_1;
    return split_1((s_1 = s, (s_1 === defaultOf()) ? "" : s_1), [separator], undefined, 1);
}

export function splitByString(separator, s) {
    let s_1;
    return split_1((s_1 = s, (s_1 === defaultOf()) ? "" : s_1), [separator], undefined, 1);
}

export function toOption(s) {
    if (isNullOrWhiteSpace(s)) {
        return undefined;
    }
    else {
        return s;
    }
}

export function toUtf8Base64(s) {
    let objectArg;
    return toBase64String((objectArg = get_UTF8(), objectArg.getBytes(s)));
}

export function ofUtf8Base64(s) {
    const bytes = fromBase64String(s);
    const objectArg = get_UTF8();
    return objectArg.getString(bytes);
}

export function ofBytesArray(b) {
    return get_UTF8().getString(b);
}

export function toBytesArray(s) {
    return get_UTF8().getBytes(s);
}

export function $007CCI$007C_$007C(s1, s2) {
    if (compare(s1, s2, 5) === 0) {
        return some(undefined);
    }
    else {
        return undefined;
    }
}

export const $007CLower$007C = toLower;

export function $007CNotEmpty$007C_$007C(s) {
    return Option_ofBool(!isNullOrWhiteSpace(s));
}

export function $007CNullOrWhiteSpace$007C_$007C(s) {
    return Option_ofBool(isNullOrWhiteSpace(s));
}

export function $007CStartsWith$007C_$007C(prefix, s) {
    return Option_ofBool(s.startsWith(prefix));
}

export function $007CBool$007C_$007C(s) {
    let tupledArg;
    let outArg = false;
    tupledArg = [tryParse(s, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    return Option_ofPair(tupledArg[0], tupledArg[1]);
}

export function $007CDateOnly$007C_$007C(s) {
    return DateOnly_tryParse(s);
}

export function $007CDateTime$007C_$007C(s) {
    const tupledArg = InvariantCulture_TryParseDateTime_Z721C83C5(s);
    return Option_ofPair(tupledArg[0], tupledArg[1]);
}

export function $007CDecimal$007C_$007C(s) {
    const tupledArg = InvariantCulture_TryParseDecimal_Z721C83C5(s);
    return Option_ofPair(tupledArg[0], tupledArg[1]);
}

export function $007CInt$007C_$007C(s) {
    let tupledArg;
    let outArg = 0;
    tupledArg = [tryParse_1(s, 511, false, 32, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
    return Option_ofPair(tupledArg[0], tupledArg[1]);
}

export function $007CPercentage$007C_$007C(s) {
    return bind($007CDecimal$007C_$007C, map_1((_arg) => trimEnd_1(_arg, "%"), ofNullable(s)));
}

